import {
  Button,
  CardContent,
  TextField,
  Typography,
  Stack,
} from "@mui/material";

import { Card } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import LeagueRegistrationTable from "./LeagueRegistrationTable";

export interface LeagueInformation {
  league_name: string;
  handicap: number;
  team_maximum: number;
  signups_open: boolean;
  tournament_id?: number;
}

interface LeagueRegistrationProps {
  onReset?: () => void;
  leaguesDetails: LeagueInformation[];
  setLeaguesDetails: Dispatch<SetStateAction<LeagueInformation[]>>;
  displayHandicap: boolean;
  title: string;
  deleteTournamentLeague: (league_id: number) => void;
}

function LeagueRegistration({
  onReset,
  leaguesDetails,
  setLeaguesDetails,
  title,
  displayHandicap,
  deleteTournamentLeague,
}: LeagueRegistrationProps) {
  const [currentLeagueDetails, setCurrentLeagueDetails] =
    useState<LeagueInformation>({
      league_name: "",
      handicap: 0,
      team_maximum: 2,
      signups_open: true,
    });

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Stack spacing={1}>
          <LeagueRegistrationTable
            leaguesDetails={leaguesDetails}
            setLeaguesDetails={setLeaguesDetails}
            displayHandicap={displayHandicap}
            displayTeamMaximum={false}
            title={title}
            deleteTournamentLeague={deleteTournamentLeague}
          />
          <TextField
            fullWidth
            label={title + " Name"}
            value={currentLeagueDetails.league_name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentLeagueDetails({
                ...currentLeagueDetails,
                league_name: e.target.value,
              })
            }
          />
          {displayHandicap && (
            <>
              <Typography variant="subtitle1">{title} Handicap</Typography>
              <Stack spacing={4}>
                <TextField
                  fullWidth
                  label="Handicap"
                  type="number"
                  value={currentLeagueDetails.handicap}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = parseInt(e.target.value);
                    if (value >= -8 && value <= 40) {
                      setCurrentLeagueDetails({
                        ...currentLeagueDetails,
                        handicap: value,
                      });
                    }
                  }}
                  /*inputProps={{
                    min: -8,
                    max: 40,
                    step: 1
                  }}*/
                />
                {/*<TextField
                  fullWidth
                  label="Max Number of Teams"
                  type="number"
                  value={currentLeagueDetails.team_maximum}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setCurrentLeagueDetails({
                      ...currentLeagueDetails,
                      team_maximum: parseInt(e.target.value) || 0,
                    })
                  }
                />*/}
              </Stack>
            </>
          )}
          <Button
            variant="contained"
            color="primary"
            style={{ width: "100%" }}
            disabled={currentLeagueDetails.league_name === ""}
            onClick={() => {
              if (currentLeagueDetails.team_maximum <= 0) {
                window.alert("Please enter a valid number of teams");
                return;
              }
              setLeaguesDetails([...leaguesDetails, currentLeagueDetails]);
              setCurrentLeagueDetails({
                league_name: "",
                handicap: 0,
                team_maximum: 2,
                signups_open: true,
              });
            }}
          >
            Add {title}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default LeagueRegistration;
